import {getStepFromAnalysis} from 'analysis-tool/data/getStepFromAnalysis';
import {
  AnalysisMainViewItem,
  AnalysisMainViewItemType,
  DataReference,
} from 'analysis-tool/ui/main-view/MainViewTypes';
import {assert} from 'Asserts';
import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineGraphQL, pipelineStepIsStepType} from 'pipelines/PipelineTypes';
import configureAndApplyStaticTemplate from 'pipelines/static-templates/configureAndApplyStaticTemplate';
import {StaticTemplateId} from 'pipelines/static-templates/GeneratedStaticTemplateUIShapes';

export interface CreateViewAndOpenExperimentOptimizationViewParams {
  analysis: PipelineGraphQL;
  inputDataFrameId: string;
  inputDataReference: DataReference;
  onOpenStepInitializationView: (newSelectedItem: AnalysisMainViewItem) => void;
}

export default function createViewAndOpenExperimentOptimizationView({
  analysis,
  inputDataFrameId,
  inputDataReference,
  onOpenStepInitializationView,
}: CreateViewAndOpenExperimentOptimizationViewParams): void {
  const inputStep = getStepFromAnalysis(analysis, inputDataReference.stepId);
  const outputStepData = inputStep.outputStepDatas.find(
    (outputStepData) => outputStepData.name === inputDataReference.stepDataName
  )!;
  const inputDataFrameIndex = outputStepData.rawDatas.findIndex((rawData) => rawData.id === inputDataFrameId);

  configureAndApplyStaticTemplate(
    StaticTemplateId.EXPERIMENT_OPTIMIZATION,
    analysis.id,
    [
      {
        step: inputStep,
        stepDataName: inputDataReference.stepDataName,
        rawDataIndex: inputDataFrameIndex,
      },
    ],
    (newSteps) => {
      const recommendationsLayoutStep = newSteps.find(
        (step) =>
          pipelineStepIsStepType(PipelineStepType.LAYOUT, 0, step) && step.config?.name === 'Recommendations'
      );
      assert(
        recommendationsLayoutStep != null,
        'Expected triggering Experiment Optimization to create a Recommendations layout step'
      );
      onOpenStepInitializationView({
        type: AnalysisMainViewItemType.DATA_LAYOUT,
        stepId: recommendationsLayoutStep.id,
      });
    }
  );
}
